export default function Technology() {
  return (
    <section id="technology" className="py-section bg-white">
      <div className="max-w-content mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-3">
            <div className="inline-block px-4 py-2 bg-calm rounded-xl mb-4">
              <span className="text-sm font-medium text-white">AI as Mechanism, Not Hero</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-heading font-semibold text-ink mb-6 tracking-tight">
              Your Photos Never Leave Our Servers
            </h2>

            <div className="space-y-6">
              <p className="text-lg text-muted leading-relaxed">
                We use computer vision to measure windows from your photos—but your images are encrypted at rest and never shared with third parties.
              </p>
              
              <p className="text-lg text-muted leading-relaxed">
                No cloud AI vendors. No training datasets. Just fast, private quotes.
              </p>

              <a 
                href="#privacy" 
                className="inline-flex items-center gap-2 text-base font-medium text-calm hover:underline cursor-pointer"
              >
                Read Our Privacy Policy
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* Right Visual */}
          <div className="lg:col-span-2">
            <div className="relative w-full h-[480px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/e719d8c66abdd2c1b8bbfd6326bc2534.jpg"
                alt="Happy mother and baby by window"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}